module.exports = __webpack_public_path__ + "img/corp-syzn_2x.69eddff7.jpg";